<template>
  <div
    class="user-list"
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-form label-position="right" label-width="80px" :model="searchParams" class="search-form">
      <el-form-item label="微信名称" class="search-box">
        <el-input v-model="searchParams.nickName"></el-input>
      </el-form-item>
      <el-form-item label="姓名" class="search-box">
        <el-input v-model="searchParams.name"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" class="search-box">
        <el-input v-model="searchParams.mobile"></el-input>
      </el-form-item>
      <el-button type="primary" class="fl-r" @click="getList">搜索</el-button>
      <el-button class="fl-r" @click="clear">重置</el-button>
      <el-button type="primary" class="fl-r" @click="addUser">新增用户</el-button>
    </el-form>
    <el-table :data="usersData" border ref="table" style="width: 100%">
      <el-table-column prop="nickName" label="微信名称" sortable></el-table-column>
      <el-table-column prop="userName" label="姓名" sortable></el-table-column>
      <el-table-column prop="mobile" label="手机号" sortable></el-table-column>
      <el-table-column label="预付训练用户" sortable>
        <template slot-scope="scope">{{scope.row.payNum?'剩余训练'+scope.row.payNum+'次':'否'}}</template>
      </el-table-column>
      <el-table-column label="预付诊疗用户" sortable>
        <template slot-scope="scope">{{scope.row.xlNum?'剩余诊疗'+scope.row.xlNum+'次':'否'}}</template>
      </el-table-column>
      <el-table-column label="操作" width="380px">
        <template slot-scope="scope">
          <!-- <el-button @click="toTables(scope.row.id)" type="info" size="small">个人信息</el-button> -->
          <el-button @click="userDetails(scope.row.id)" type="info" size="small">修改信息</el-button>
          <el-button @click="toDetails(scope.row.id)" type="primary" size="small">预约课程</el-button>
          <el-button @click="toPayNum(scope.row.id)" type="success" size="small">预付修改</el-button>
          <el-button
            @click="toCharts(scope.row.id,scope.row.userName)"
            type="warning"
            size="small"
          >统计图表</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar.vue";
import HelpHint from "@/components/HelpHint.vue";

export default {
  data() {
    return {
      searchParams: {
        mobile: "",
        nickName: "",
        payNum: "0",
        name: ""
      },
      usersData: [],
      loading: false
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      var that = this;
      that.loading = true;
      that.usersData = [];
      that.$axios
        .post(that.baseUrl + "/queryWxUserAll", {
        // .post("/gymTest/queryWxUserAll", {
          ...that.searchParams
        })
        .then(res => {
          console.log(res);
          for (var i = 0; i < res.data.data.length; i++) {
            if (res.data.data[i].userName) {
              that.usersData.push(res.data.data[i]);
            }
          }
          that.loading = false;
          // that.usersData = res.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addUser() {
      this.$router.push("/user_add");
    },
    userDetails(id) {
      this.$router.push("/user_add?id=" + id);
    },
    clear() {
      this.searchParams = {
        mobile: "",
        nickName: "",
        payNum: "0",
        name: ""
      };
      this.getList();
    },
    toDetails(id) {
      this.$router.push("/user_course?id=" + id);
    },
    toPayNum(id) {
      this.$router.push("/user_payNum?id=" + id);
    },
    toCharts(id, name) {
      this.$router.push("/user_charts?id=" + id + "&name=" + name);
    },
    toTables(id) {
      this.$router.push("/user_tables?id=" + id);
    }
  },
  components: {
    ToolBar,
    HelpHint
  }
};
</script>
<style lang="less" scoped>
.search-form {
  margin: 20px auto 0;
  overflow: hidden;
}
.search-box {
  width: 24%;
  float: left;
}
.page-box {
  background: #fff;
  text-align: center;
  padding: 20px 0;
}
.fl-r {
  margin-left: 20px;
}
</style>
